import BaseComponent from '../base/baseComponent';
import micromodalInstance from '../libs/micromodalInstance';
export default class NotifymeTrigger extends BaseComponent {
    get SELECTORS() {
        return {
            notifymeModal: '#modal-notifyme',
            pidInput: '.form--notifyme input[name="pid"]'
        };
    }
    constructor(element) {
        super(element);
        this.handleClick();
    }
    handleClick() {
        this._el.addEventListener('click', (e) => {
            const notifymeModal = document.querySelector(this.SELECTORS.notifymeModal);
            if (notifymeModal) {
                const pidInput = notifymeModal.querySelector(this.SELECTORS.pidInput);
                if (pidInput) {
                    pidInput.value = this._options.pid;
                }
                micromodalInstance.forceShow('modal-notifyme');
            }
        });
    }
}
